import { useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const location = useLocation();

  if (isLoading) {
    return null; // or loading spinner
  }

  if (!isAuthenticated) {
    // You can trigger loginWithRedirect here or redirect to login page:
    loginWithRedirect({
      appState: { returnTo: location.pathname },
    });
    return null;
  }

  return children;
};

export default ProtectedRoute;
